import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const EmailAccountsView = lazy(() => import("../components/EmailAccounts/ParentEmailAccountsView.jsx"));

export default [
  { path: ROUTES.EMAIL.ACCOUNTS, element: <LazyRoute><EmailAccountsView /></LazyRoute> },
];
